import * as Turbo from "@hotwired/turbo"
import { StreamActions } from "@hotwired/turbo"
import { showToast } from "./show_toast"

// Toast: <turbo-stream action="toast" type="success" message="Saved!"></turbo-stream>
// Sticky: sticky="true" theme="trip-complete"
StreamActions.toast = function toast() {
  const message = this.getAttribute("message")
  const type = this.getAttribute("type") || "notice"
  const sticky = this.getAttribute("sticky") === "true"
  const themeAttr = this.getAttribute("theme")
  const durationAttr = this.getAttribute("duration")

  if (!message) return

  const isError = type === "alert" || type === "error"
  const theme = themeAttr || (isError ? "error" : "success")
  const options = sticky
    ? {
        autoClose: false,
        showProgressBar: false,
        showCloseButton: true,
        closeButtonColor: "#ffffff"
      }
    : {}

  if (!sticky && durationAttr) {
    const duration = Number(durationAttr)
    if (Number.isFinite(duration) && duration > 0) {
      options.duration = duration
    }
  }

  showToast(message, theme, options)
}

// <turbo-stream action="dispatch_event" event-name="admin:refresh-sidebar-counts"></turbo-stream>
StreamActions.dispatch_event = function dispatchEvent() {
  const name = this.getAttribute("event-name")
  if (!name) return

  document.dispatchEvent(new CustomEvent(name, { bubbles: false }))
}

// Sync address bar when a GET response uses turbo-stream without a full Drive visit.
// <turbo-stream action="advance_url" url="..."></turbo-stream>
StreamActions.advance_url = function advanceUrl() {
  const raw = this.getAttribute("url")
  if (!raw) return

  const next = new URL(raw, window.location.origin)
  Turbo.session.history.push(next)
}

// Navigate after a Turbo Stream response, e.g. after a successful form submit from a nested frame.
// <turbo-stream action="visit" url="..." frame="admin-workspace" turbo-action="advance"></turbo-stream>
// Use Turbo.visit (not frame.src alone) so framed navigations also advance the address bar —
// session.visit calls proposeVisitIfNavigatedWithAction before setting src.
StreamActions.visit = function visit() {
  const raw = this.getAttribute("url")
  if (!raw) return

  const url = new URL(raw, window.location.origin).toString()
  const frameId = this.getAttribute("frame")
  const action = this.getAttribute("turbo-action") || "advance"

  if (frameId) {
    Turbo.visit(url, { frame: frameId, action })
    return
  }

  Turbo.visit(url, { action })
}
